import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import GroupIcon from "@mui/icons-material/Group";
import { GetVlpUsers } from "../../../services/UsersService";
import CommonLoader from "../../common/CommonLoader";
import AccessGroups from "./AccessGroups";

const GroupAccessControl = () => {
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOperator, setSelectedOperator] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const response = await GetVlpUsers();
        setUsersData(response.results || []);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  if (selectedOperator) {
    return (
      <>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => setSelectedOperator(null)}
          style={{ marginBottom: "16px" }}
        >
          Back to User List
        </Button>
        <AccessGroups userId={selectedOperator} embedded />
      </>
    );
  }

  const filteredData = usersData.filter((user) =>
    ["operator", "aliasName", "fullName", "email"].some((field) =>
      (user[field] || "").toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  return (
    <>
      <TextField
        label="Search Users"
        variant="outlined"
        size="small"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: "16px", width: "100%" }}
      />
      <Paper>
        <TableContainer sx={{ maxHeight: 500, overflowY: "auto" }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Operator</TableCell>
                <TableCell>Alias Name</TableCell>
                <TableCell>Full Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell align="right">Manage Groups</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.map((user) => (
                <TableRow key={user.operator} hover>
                  <TableCell>{user.operator}</TableCell>
                  <TableCell>{user.aliasName}</TableCell>
                  <TableCell>{user.fullName}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell align="right">
                    <Button
                      size="small"
                      startIcon={<GroupIcon />}
                      onClick={() => setSelectedOperator(user.operator)}
                    >
                      Manage
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <CommonLoader loading={loading} />
    </>
  );
};

export default GroupAccessControl;
